export function getCurrentUserType() {
  try {
    const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}') || {}
    return String(userInfo.userType || '')
  } catch (error) {
    return ''
  }
}

export function withoutAdminSchoolId(data) {
  if (!data || getCurrentUserType() !== '00') return data
  const nextData = Object.assign({}, data)
  delete nextData.schoolId
  return nextData
}



// WEBPACK FOOTER //
// ./src/utils/systemRequestScope.js